import { render, staticRenderFns } from "./TransferExamine.vue?vue&type=template&id=2ad34eba&scoped=true"
import script from "./TransferExamine.vue?vue&type=script&lang=js"
export * from "./TransferExamine.vue?vue&type=script&lang=js"
import style0 from "./TransferExamine.vue?vue&type=style&index=0&id=2ad34eba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad34eba",
  null
  
)

export default component.exports